import * as Yup from 'yup';

export default Yup.object().shape({
  title: Yup.string().max(100, 'Field must be atmost 100 characters.').required('This is a required field.')
});
